import { useMemo } from "react";

import { useAdoptedBudgetMix } from "@features/mmm/hooks/use-adopted-budget-mix";

import { usePerformanceTrackingData } from "./performance-tracking-provider";

export const usePerformanceTrackingKpiData = () => {
  const { adoptedBudgetMix } = useAdoptedBudgetMix();

  const { loading, data } = usePerformanceTrackingData();

  const trackingKpiData = useMemo(() => {
    const performanceTrackingData = data?.me?.mmm?.performanceTracking
      ?.performanceTrackingKpiData ?? {
      planningTarget: 0,
      targetRange: {
        low: 0,
        median: 0,
        high: 0,
      },
      weeklyMetrics: [],
      dailyMetrics: [],
    };

    return performanceTrackingData;
  }, [data]);

  const isLoading =
    loading || trackingKpiData.weeklyMetrics.length === 0 || !adoptedBudgetMix;

  return {
    loading: isLoading,
    trackingKpiData,
  };
};
